import { GraphQLClient } from 'graphql-request'
import { VAA_FLIGHTS_SEARCH_URL } from '@/config'

let client: GraphQLClient | null = null

export function getVaaGQLClient() {
  client ??= new GraphQLClient(VAA_FLIGHTS_SEARCH_URL)
  return client
}
